export default __webpack_public_path__ + "static/media/Pin-Warning.58159b83.svg";